export default function StrutturaSection() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-10 lg:gap-12">
          {/* Immagine a sinistra */}
          <div className="w-full lg:w-1/2">
            <div className="relative w-full h-[300px] sm:h-[400px] lg:h-[600px] rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/976dcb7e0beef775b1be545a19fb88ff.jpg"
                alt="Struttura del sistema Brand Capital"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          {/* Contenuto a destra */}
          <div className="w-full lg:w-1/2">
            <div className="inline-block px-4 py-2 bg-[#22C55E]/10 rounded-full mb-4 sm:mb-6">
              <span className="text-sm font-semibold text-[#22C55E]">La Struttura</span>
            </div>
            
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6 leading-tight">
              Struttura del sistema Brand Capital
            </h2>
            
            <p className="text-base sm:text-lg text-[#1C1C1C]/80 mb-6 sm:mb-8 lg:mb-10 leading-relaxed">
              Il sistema Brand Capital si articola in quattro componenti principali:
            </p>

            <div className="space-y-4 sm:space-y-5 lg:space-y-6">
              <div className="bg-slate-50 p-4 sm:p-5 lg:p-6 rounded-xl border-l-4 border-[#22C55E]">
                <h3 className="text-lg sm:text-xl font-bold text-[#0B1F3B] mb-2">Brand Capital Index (BCI)</h3>
                <p className="text-sm sm:text-base text-[#1C1C1C]/80 leading-relaxed">
                  Modello di misurazione che consente di analizzare il valore del brand attraverso indicatori economici, di mercato, digitali e di governance.
                </p>
              </div>

              <div className="bg-slate-50 p-4 sm:p-5 lg:p-6 rounded-xl border-l-4 border-[#22C55E]">
                <h3 className="text-lg sm:text-xl font-bold text-[#0B1F3B] mb-2">Brand Capital Report</h3>
                <p className="text-sm sm:text-base text-[#1C1C1C]/80 leading-relaxed">
                  Documento tecnico che formalizza i risultati dell'analisi e rende il valore del brand documentabile e difendibile.
                </p>
              </div>

              <div className="bg-slate-50 p-4 sm:p-5 lg:p-6 rounded-xl border-l-4 border-[#22C55E]">
                <h3 className="text-lg sm:text-xl font-bold text-[#0B1F3B] mb-2">Brand Capital Framework</h3>
                <p className="text-sm sm:text-base text-[#1C1C1C]/80 leading-relaxed">
                  Modello operativo di governance che trasforma la misurazione in gestione continuativa del brand come asset.
                </p>
              </div>

              <div className="bg-slate-50 p-4 sm:p-5 lg:p-6 rounded-xl border-l-4 border-[#22C55E]">
                <h3 className="text-lg sm:text-xl font-bold text-[#0B1F3B] mb-2">Brand Capital Dashboard</h3>
                <p className="text-sm sm:text-base text-[#1C1C1C]/80 leading-relaxed">
                  Strumento di monitoraggio che rende il valore del brand osservabile nel tempo e traccia l'impatto delle decisioni aziendali.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}